import React from "react";
import { Tag } from "antd";
import clsx from "clsx";

const CommonTag = ({ className, ...others }) => {
  return <Tag className={clsx("__tagLarge", className)} {...others} />;
};

export default CommonTag;
